/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCrop54 = createReactComponent("crop-5-4", "IconCrop54", [
  [
    "path",
    {
      d: "M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ]
]);

export { IconCrop54 as default };
//# sourceMappingURL=IconCrop54.js.map
